import React, { Fragment, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import Carousel from 'react-multi-carousel';
import '../../carousel-styles.css';

import MFlexbox from '../MFlexbox';
import { ProductImage } from '../ProductImage';
import { MText } from '../MText';

import { StyledImageCarouselCon, StyledImageCarouselOverlay } from './skins';

import { getFourSideStringFormat } from '../../helpers/style';

export const MImageCarousel = ({
  images,
  imageWidth,
  imageHeight,
  imageMobileWidth,
  imageMobileHeight,
  imageIsBordered,
  imageBorderColor,
  imageBorderWidth,
  imageBorderRadius,
  imagePadding,
  imageMargin,
  arrowColor,
  imageIndex,
  showAddedOverlay,
  overlayText,
  overlayColor,
  overlayTextStyles = {},
  onImageClick = () => {},
  showImagesGrid,
  imageGridItemStyles,
  isProductImageClickGoToPage = true,
  className = '',
}) => {
  const [currImageIndex, setCurrImageIndex] = useState(imageIndex);
  const [carouselElement, setCarouselElement] = useState(null);

  const carouselRef = useCallback(node => {
    if (node) {
      setCarouselElement(node);
      node.goToSlide(imageIndex > -1 ? imageIndex : 0);
    }
  });

  const responsive = {
    any: {
      breakpoint: { max: 4000, min: 0 },
      items: 1,
    },
  };

  useEffect(
    () => {
      if (carouselElement && imageIndex > -1) {
        carouselElement.goToSlide(imageIndex);
      }
    },
    [imageIndex],
  );

  const onImagesGridItemClick = index => {
    if (!carouselElement) return;

    carouselElement.goToSlide(index);
  };

  return (
    <StyledImageCarouselCon
      className={`${className} mr-images-carousel`}
      imageWidth={imageWidth}
      imageHeight={imageHeight}
      borderRadius={getFourSideStringFormat(imageBorderRadius)}
      arrowColor={arrowColor}
    >
      {showAddedOverlay && (
        <StyledImageCarouselOverlay
          backgroundColor={`${overlayColor}99`}
          className="mr-images-carousel__overlay"
        >
          <MText
            className="mr-image-carousel__overlay-text"
            width="100%"
            {...overlayTextStyles}
          >
            {overlayText}
          </MText>
        </StyledImageCarouselOverlay>
        // <Overlay color={overlayColor} {...overlayTextStyles}>
        // </Overlay>
      )}
      <Carousel
        arrows
        ref={carouselRef}
        responsive={responsive}
        beforeChange={nextSlide => setCurrImageIndex(nextSlide)}
        containerClass="mr-images-carousel__carousel-con"
      >
        {images.map((image, i) => (
          <Fragment key={`key-${i * 1}`}>
            <ProductImage
              src={image.src}
              width={imageWidth}
              height={imageHeight}
              mobileWidth={imageMobileWidth}
              mobileHeight={imageMobileHeight}
              isBordered={imageIsBordered}
              borderWidth={imageBorderWidth}
              borderRadius={imageBorderRadius}
              borderColor={imageBorderColor}
              padding={imagePadding}
              margin={imageMargin}
              onImageClick={onImageClick}
              cursor={isProductImageClickGoToPage ? 'pointer' : 'auto'}
              className="mr-images-carousel__image"
            />
          </Fragment>
        ))}
      </Carousel>
      {showImagesGrid && (
        <MFlexbox
          className="mr-images-carousel__images-grid"
          width={imageWidth}
        >
          {images.map((image, i) => {
            const isSelected = i === currImageIndex;
            const { isBordered, borderColor } = imageGridItemStyles;
            return (
              <Fragment key={`key-${i * 1}`}>
                <ProductImage
                  src={image.src}
                  {...imageGridItemStyles}
                  isBordered={isBordered || isSelected}
                  borderColor={isSelected ? arrowColor : borderColor}
                  onImageClick={() => onImagesGridItemClick(i)}
                  className="mr-images-grid__image-item"
                />
              </Fragment>
            );
          })}
        </MFlexbox>
      )}
    </StyledImageCarouselCon>
  );
};

MImageCarousel.propTypes = {
  images: PropTypes.array,
  imageWidth: PropTypes.string,
  imageHeight: PropTypes.string,
  imageBorderRadius: PropTypes.string,
  imageMobileWidth: PropTypes.string,
  imageMobileHeight: PropTypes.string,
  imageIsBordered: PropTypes.bool,
  imageBorderColor: PropTypes.string,
  imageBorderWidth: PropTypes.string,
  imagePadding: PropTypes.string,
  imageMargin: PropTypes.string,
  arrowColor: PropTypes.string,
  imageIndex: PropTypes.number,
  showImagesGrid: PropTypes.bool,
  imageGridItemStyles: PropTypes.object,
  showAddedOverlay: PropTypes.bool,
  overlayColor: PropTypes.string,
  overlayText: PropTypes.string,
  overlayTextStyles: PropTypes.object,
  onImageClick: PropTypes.func,
  isProductImageClickGoToPage: PropTypes.bool,
};
